function searchRules(app) {
  return {
    //オーナーID  チェック  ・桁数チェック   ・型チェック
    ownerExId: [
      {
        max: 20,
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.owner.search.query.ownerExId'),
          length: 20
        }),
        trigger: 'change'
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'change',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.system.owner.search.query.ownerExId'),
          type: '半角英数字'
        })
      }
    ],

    //オーナー名  チェック  ・桁数チェック   ・型チェック
    ownerName: [
      {
        max: 50,
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.owner.search.query.ownerName'),
          length: 50
        }),
        trigger: 'change'
      }
    ]
  }
}

export default {
  searchRules: searchRules
}
